/* @flow */

import CommissionSummaryIsoPerson from './commissionSummaryIsoPerson';

export default class CommissionSummaryIsoOffice {
  id: number;
  name: string;
  persons: CommissionSummaryIsoPerson[];
  financedInvoiceCommission: number;
  unfinancedInvoiceCommission: number;
  msfCommission: number;
  membershipCommission: number;
  totalCommission: number;

  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
    this.persons = [];
    this.financedInvoiceCommission = 0;
    this.unfinancedInvoiceCommission = 0;
    this.msfCommission = 0;
    this.membershipCommission = 0;
    this.totalCommission = 0;
  }
}
